export default {"src":"/_next/static/media/plantingMachine.cf2f3914.svg","height":445,"width":854,"blurWidth":0,"blurHeight":0};